<template>
  <div class="myaccount">
    <div class="breadcrumb" style="background: #fff">我的账号信息</div>
    <div class="third-title">我的账号</div>
    <div class="order-detail-basic">
      <el-form :model="account" label-width="80px">
        <el-form-item label="用户名:">{{ account.userName }}</el-form-item>
        <el-form-item label="密码:">
          <el-button round @click="$router.push('./myaccountpass')">修改密码</el-button>
        </el-form-item>
        <el-form-item class="noleft-third-title">
          <div class="third-title">我的收货地址</div>
        </el-form-item>
        <el-form-item label="收货地址:">
          <el-button round @click="type = 'add', dialogVisible = true">添加地址</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-table border class="table-cell" :row-class-name="rowClassName" :data="tableList">
            <el-table-column prop="person" label="收货人" min-width="100px"></el-table-column>
            <el-table-column label="地址" min-width="100px">
              <template v-slot="scope">
                <span>{{ scope.row.completeAddress }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="100px"></el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template v-slot="scope">
                <span class="color-blue" :class="scope.row.isDefaultAddress === 1 ? 'defult' : ''" @click="setDefult(scope.row.id)"> {{ scope.row.isDefaultAddress === 1 ? '默认地址' : '设为默认' }} </span>
                <span class="color-blue" @click="editAddress(scope.row)" style="margin: 0 5px">编辑</span>
                <span class="color-blue" @click="delAddressDialog = true, deleteAddressId = scope.row.id">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <!-- 删除地址 -->
    <el-dialog :close-on-click-modal="false" title="删除确认" :visible.sync="delAddressDialog" width="30%" :before-close="handleClose">
      <span>确认删除该地址吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delAddressDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteAddress(deleteAddressId)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加收货地址 -->
    <el-dialog :close-on-click-modal="false" title="收货地址" :visible.sync="dialogVisible" @closed="closed" width="45%">
      <el-form ref="form" inline :model="userAddressVo" hide-required-asterisk :rules="rules" label-width="80px">
        <div>
          <el-form-item label="收货人:" prop="person">
            <el-input v-model="userAddressVo.person"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone">
            <el-input v-model="userAddressVo.phone"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="地址信息:" prop="address">
          <el-select v-model="selectAddress.sheng" value-key="code" @change="getAllshi" clearable>
            <el-option v-for="(option, index) in address.sheng" :key="'provinces' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.shi" style="margin:0 10px" value-key="id" @change="getAllQu" clearable>
            <el-option v-for="(option, index) in address.shi" :key="'city' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.qu" @change="$refs.form.validateField('address')" value-key="id" clearable>
            <el-option v-for="(option, index) in address.qu" :key="'region' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址:" prop="fullAddress">
          <el-input v-model="userAddressVo.fullAddress" style="width:560px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAddress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { userQueryByUserId, updateAddress, saveUserAddress, addressDelete, addressSetDefault, addressGetAllProvince, addressGetCityByProvinceCode, addressGetCountyByCityId, getAddressByUserId } from '@/api/crm'
export default {
  name: 'myaccount',
  data () {
    var checkAddress = (rule, value, callback) => {
      if (this.selectAddress.qu === '') {
        callback(new Error('未选择完整的地址信息'))
      } else {
        callback()
      }
    }
    return {
      delAddressDialog: false,
      rules: {
        person: [
          { required: true, message: '请输入收货人', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { validator: this.$FormRules.checkPhone, trigger: 'blur' }
        ],
        address: [
          { required: true, validator: checkAddress, trigger: 'blur' }
        ],
        fullAddress: [
          { required: true, message: '请输入详细地址', trigger: 'change' }
        ]
      },
      type: '',
      editAddressId: '',
      userAddressVo: {
        city: '',
        cityId: '',
        county: '',
        countyId: '',
        fullAddress: '',
        person: '',
        phone: '',
        province: '',
        provinceCode: '',
        userId: ''
      },
      selectAddress: {
        sheng: '',
        shi: '',
        qu: ''
      },
      address: {
        sheng: [],
        shi: [],
        qu: []
      },
      dialogVisible: false,
      account: {
        userName: ''
      },
      tableList: []
    }
  },
  created () {
    this.getAccount()
    this.getAddress()
    this.getAllSheng()
  },
  methods: {
    closed () {
      // this.userAddressVo = {
      //   city: '',
      //   cityId: '',
      //   county: '',
      //   countyId: '',
      //   fullAddress: '',
      //   person: '',
      //   phone: '',
      //   province: '',
      //   provinceCode: '',
      //   userId: ''
      // }
      this.selectAddress = {
        sheng: '',
        shi: '',
        qu: ''
      }
      this.$refs.form.resetFields()
    },
    // 编辑地址
    editAddress (row) {
      this.selectAddress = {
        sheng: {
          code: row.provinceCode,
          name: row.province
        },
        shi: {
          id: row.cityId,
          name: row.city
        },
        qu: {
          id: row.countyId,
          name: row.county
        }
      }
      this.getAllshi()
      this.getAllQu()
      this.editAddressId = row.id
      this.userAddressVo = row
      this.type = 'edit'
      this.dialogVisible = true
    },
    // 删除地址
    deleteAddress (id) {
      addressDelete(id).then(res => {
        if (res.data.success) {
          this.getAddress()
          this.$message.success('删除成功')
          this.delAddressDialog = false
        }
      })
    },
    // 设为默认
    setDefult (id) {
      addressSetDefault(id).then(res => {
        if (res.data.success) {
          this.$message.success('更改成功')
          this.getAddress()
        }
      })
    },
    // 添加地址
    addAddress () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        let userAddressVo = {
          city: this.selectAddress.shi.name,
          cityId: this.selectAddress.shi.id,
          county: this.selectAddress.qu.name,
          countyId: this.selectAddress.qu.id,
          fullAddress: this.userAddressVo.fullAddress,
          person: this.userAddressVo.person,
          phone: this.userAddressVo.phone,
          province: this.selectAddress.sheng.name,
          provinceCode: this.selectAddress.sheng.code,
          userId: localStorage.getItem('userId')
        }
        if (this.type === 'add') {
          saveUserAddress(userAddressVo).then(res => {
            if (res.data.success) {
              this.$message.success('添加成功')
              this.getAddress()
              this.userAddressVo = { city: '', cityId: '', county: '', countyId: '', fullAddress: '', person: '', phone: '', province: '', provinceCode: '', userId: '' }
              this.address = { sheng: [], shi: [], qu: [] }
              this.dialogVisible = false
            }
          })
        } else if (this.type === 'edit') {
          userAddressVo.id = this.editAddressId
          updateAddress(userAddressVo).then(res => {
            if (res.data.success) {
              this.$message.success('修改成功')
              this.getAddress()
              this.userAddressVo = { city: '', cityId: '', county: '', countyId: '', fullAddress: '', person: '', phone: '', province: '', provinceCode: '', userId: '' }
              this.address = { sheng: [], shi: [], qu: [] }
              this.dialogVisible = false
            }
          })
        }
      })
    },
    // 根据用户id获取地址
    getAddress () {
      getAddressByUserId(localStorage.getItem('userId')).then(res => {
        if (res.data.success) {
          this.tableList = res.data.data.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
      this.tableList[rowIndex].index = rowIndex
    },
    getAccount () {
      let userId = window.localStorage.getItem('userId')
      userQueryByUserId(userId).then((res) => {
        if (res.data.success) {
          this.account = res.data.data
          this.account.userName = this.$msg.filterBridal(res.data.data.userName)
        }
      })
    },
    editItem (item) {
      this.$refs.addressRef.show('edit', item, item.index)
    },
    newAddress (val) {
      let newList = {
        username: val[0],
        phone: val[5],
        address: val[1] + '省 ' + val[2] + '市 ' + val[3] + ' ',
        detail: val[4],
        operation: {
          status: '设为默认',
          edit: '编辑',
          delete: '删除'
        }
      }
      let len = val[val.length - 1]
      if (len !== '') {
        if (this.tableList[len].operation.status === '默认地址') {
          newList.operation.status = '默认地址'
        }
        this.$set(this.tableList, len, newList)
      } else {
        this.tableList.push(newList)
      }
    },
    changeStatus (status) {
      let index = status.index
      if (status.operation.status !== '默认地址') {
        for (let i = 0; i < this.tableList.length; i++) {
          this.tableList[i].operation.status = '设为默认'
        }
        this.tableList[index].operation.status = '默认地址'
        this.tableList.splice(index, 1)
        this.tableList.unshift(status)
      }
    },
    getAllQu () {
      if (this.selectAddress.shi === '') {
        this.selectAddress.qu = ''
        return
      }
      addressGetCountyByCityId(this.selectAddress.shi.id).then(res => {
        if (res.data.success) {
          this.address.qu = res.data.data
        }
      })
    },
    getAllshi () {
      if (this.selectAddress.sheng === '') {
        this.selectAddress.shi = ''
        this.selectAddress.qu = ''
        return
      }
      addressGetCityByProvinceCode(this.selectAddress.sheng.code).then(res => {
        if (res.data.success) {
          this.address.shi = res.data.data
        }
      })
    },
    getAllSheng () {
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.address.sheng = res.data.data
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";
@deep: ~">>>";

.defult {
  color: #ccc !important;
}
</style>
